document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        if (!window?.main_slider?.swiperMainSlider?.length) {
            return;
        }
        window.main_slider.swiperMainSlider.forEach((swiper) => {
            swiper.params.pagination = {
                ...window.main_slider.swiperMainSlider[0].params.pagination,
                el: '.swiper-pagination',
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
                clickable: true,
            };
            swiper.pagination.init();
            swiper.pagination.render();
            swiper.pagination.update();
        });
    }, 1);
});

document.addEventListener('DOMContentLoaded', () => {
    const sidebar = document.querySelector('.content-wrapper__column') !== null;

    if (sidebar) document.querySelectorAll('.main-slider').forEach((slider) => slider.classList.remove('no-sidebar'));
});
